// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"26":"eec2c3d2d9713eea","2417":"f5871663ea709ff8","3467":"015e645ffb468028","3988":"c191650d6352e3fe","8914":"7be48a9eb36627a3"}[chunkId] + ".js";
};